import { useIntl } from "react-intl";
import { TableHeaderProps } from "@cdkglobal/radial";

interface UseTableHeaderPropsParams {
  tableTitleInfo: string;
  searchValue: string;
  hasNoRows: boolean;
  handleExportRecords: () => void;
  handleSearchInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSearchInputClear: () => void;
}

export function useTableHeaderProps({
  tableTitleInfo,
  searchValue,
  hasNoRows,
  handleExportRecords,
  handleSearchInputChange,
  handleSearchInputClear,
}: UseTableHeaderPropsParams): TableHeaderProps {
  const { formatMessage } = useIntl();

  return {
    id: "setup-table-header",
    dataTestId: "setup-table-header",
    headerTitle: tableTitleInfo,
    hideBorder: true,
    hideTableTitle: false,
    isAlwaysExpanded: false,
    isDownloadable: true,
    onDownloadClick: handleExportRecords,
    downloadButtonText: formatMessage({
      id: "button.exportRecords",
      defaultMessage: "Export Records",
    }),
    disableDownloadButton: hasNoRows,
    isPrintable: false,
    isSearchable: true,
    onSearchInputChange: handleSearchInputChange,
    onSearchInputClear: handleSearchInputClear,
    searchInputName: "table-search-input-name",
    searchInputValue: searchValue,
    searchPlaceholder: formatMessage({
      id: "table.search.placeholder",
      defaultMessage: "Type to search",
    }),
  };
}
